import { IQueryCommandOptions } from '@llws/dynamic-router-utils';
import {
  IFloorplanNavigatorInstancePointsOfInterest,
} from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '../../shared/classes/store-base-implementation-v2';

const adminGatewayResourcePath: string = '/web-components-api/floorplan_navigator_instance_points_of_interest';
const listViewName: string = '';
const showLogging: boolean = false;
const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    { path: 'fpnipoi.fpnInstancePointOfInterestMedia', alias: 'fpnipoim' },
  ],
  select: [
    'fpnipoi.fpnInstanceId',
    'fpnipoi.title',
    'fpnipoi.subTitle',
    'fpnipoi.content',
    'fpnipoi.virtualTourEmbedCode',
    'fpnipoi.videoEmbedCode',
    'fpnipoi.status',
    'fpnipoim.fpnInstancePointOfInterestId',
    'fpnipoim.path',
    'fpnipoim.order',
  ],
  limit: 'false',
  alias: 'fpnipoi',
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  alias: 'fpnipoi',
  relations: [
    { path: 'fpnipoi.fpnInstancePointOfInterestMedia', alias: 'fpnipoim' },
  ],
  select: [
    'fpnipoi.fpnInstanceId',
    'fpnipoi.title',
    'fpnipoi.subTitle',
    'fpnipoi.content',
    'fpnipoi.virtualTourEmbedCode',
    'fpnipoi.videoEmbedCode',
    'fpnipoi.status',
    'fpnipoim.fpnInstancePointOfInterestId',
    'fpnipoim.path',
    'fpnipoim.order',
  ],
};
const base = new StoreBaseImplementationV2<IFloorplanNavigatorInstancePointsOfInterest>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
